module.exports = __webpack_public_path__ + "static/media/ductless.603f3a38.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ductless.png
// module id = 154
// module chunks = 0